import React from "react";

const SimulatorPdf = ({
  totalPremium,
  paymentPremium,
  termMonth,
  paymentDate,
  creditData,
}) => {
  const formatDate = new Date(`${paymentDate}T00:00:00`);

  let simulatorArr = [];

  if (termMonth > 0) {
    simulatorArr = Array.from({ length: termMonth }, () => Array(6).fill(0));

    for (let i = 0; i < simulatorArr.length; i++) {
      const newDate = new Date(formatDate);
      newDate.setMonth(formatDate.getMonth() + i);

      const valueByMonth = totalPremium / (termMonth - 1);

      const day = newDate.getDate();
      const month = newDate.getMonth() + 1;
      const year = newDate.getFullYear();

      simulatorArr[i][1] = `${day}/${month}/${year}`;
      simulatorArr[i][2] = paymentPremium;

      if (i !== 0) {
        for (let i = 1; i < simulatorArr.length; i++) {
          simulatorArr[i][2] = valueByMonth;
        }
      }
    }
  }

  const elements = [];

  for (let index = 0; index < termMonth; index++) {
    const monthNames = [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ];

    const dateParts = simulatorArr[index][1].split("/");
    const formattedDate = `${monthNames[parseInt(dateParts[1]) - 1]}-${
      dateParts[2]
    }`;

    elements.push(
      <tr
        style={{
          borderBottom: "1px solid #777777",
          textAlign: "center",
        }}
      >
        <td
          style={{
            borderRight: "1px solid #777777",
            padding: "0.5rem 0",
            borderBottom: "1px solid #777777",
            color: "#000000",
          }}
        >
          {index === 0 ? "Separación" : `Cuota No. ${index}`}
        </td>
        <td
          style={{
            borderRight: "1px solid #777777",
            padding: "0.5rem 0",
            borderBottom: "1px solid #777777",
            color: "#000000",
          }}
        >
          {formattedDate}
        </td>
        <td
          style={{
            padding: "0.5rem 0",
            borderBottom: "1px solid #777777",
            color: "#000000",
          }}
        >
          $
          {Math.round(
            index === 0
              ? parseFloat(simulatorArr[0][2])
              : simulatorArr[index][2]
          ).toLocaleString()}
        </td>
      </tr>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        rowGap: "2rem",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "3.5rem",
          display: "flex",
          justifyContent: "space-between",
          marginTop: "5rem",
          marginBottom: "5rem",
          alignItems: "center",
        }}
      >
        <img
          src="/assets/logo-otacc.webp"
          style={{
            width: "auto",
            height: "4rem",
            marginLeft: "10rem",
          }}
          alt=""
        />
        <img
          src="/assets/logo.webp"
          style={{
            width: "auto",
            height: "6rem",
            marginRight: "10rem",
          }}
          alt=""
        />
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontWeight: "bold",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            backgroundColor: "#dfe6ed",
            width: "85%",
          }}
        >
          <h1
            style={{
              fontSize: "1rem",
              fontWeight: "400",
              marginLeft: "1rem",
            }}
          >
            1. INFORMACION GENERAL DEL PROYECTO
          </h1>
        </div>
        <div
          style={{
            width: "85%",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
          }}
        >
          <ul
            style={{
              listStyle: "none",
              padding: "0",
              display: "flex",
              flexDirection: "column",
              rowGap: "1rem",
            }}
          >
            <li
              style={{
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              SOCIEDAD FIDUCIARIA: Alianza Fiduciaria
            </li>
            <li
              style={{
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              Proyecto de interes Club Residencial Reserva del prado
            </li>
          </ul>
          <ul
            style={{
              listStyle: "none",
              padding: "0",
            }}
          >
            <li
              style={{
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              Tipo de negociación: Credito
            </li>
          </ul>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontWeight: "bold",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            backgroundColor: "#dfe6ed",
            width: "85%",
          }}
        >
          <h1
            style={{
              fontSize: "1rem",
              fontWeight: "400",
              marginLeft: "1rem",
            }}
          >
            2. INFORMACION GENERAL COMPRADORES
          </h1>
        </div>
        <div
          style={{
            width: "85%",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
          }}
        >
          <ul
            style={{
              listStyle: "none",
              padding: "0",
              display: "flex",
              flexDirection: "column",
              rowGap: "1rem",
            }}
          >
            <li
              style={{
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              Nombre de la cuenta: {creditData?.name}
            </li>
            <li
              style={{
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              Tipo Identificación: {creditData?.type_doc}
            </li>
            <li
              style={{
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              Número de Identificación: {creditData?.num_doc}
            </li>
            <li
              style={{
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              Correo Electrónico personal: {creditData?.email}
            </li>
          </ul>
          <ul
            style={{
              listStyle: "none",
              padding: "0",
            }}
          >
            <li
              style={{
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              Ingresos Mensuales ${" "}
              {Number(creditData?.monthly_income).toLocaleString("es-CO")}
            </li>
          </ul>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontWeight: "bold",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            backgroundColor: "#dfe6ed",
            width: "85%",
          }}
        >
          <h1
            style={{
              fontSize: "1rem",
              fontWeight: "400",
              marginLeft: "1rem",
            }}
          >
            INFORMACION DEL APARTAMENTO
          </h1>
        </div>
        <div
          style={{
            width: "85%",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
          }}
        >
          <ul
            style={{
              listStyle: "none",
              padding: "0",
              display: "flex",
              flexDirection: "column",
              rowGap: "1rem",
            }}
          >
            <li
              style={{
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              Torre: {creditData?.block}
            </li>
            <li
              style={{
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              Piso: {creditData?.floor}
            </li>
            <li
              style={{
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              Numero de apartamento: {creditData?.apartment}
            </li>
          </ul>
          <ul
            style={{
              listStyle: "none",
              padding: "0",
              display: "flex",
              flexDirection: "column",
              rowGap: "1rem",
            }}
          >
            <li
              style={{
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              Piso parqueadero: {creditData?.parking_floor}
            </li>
            <li
              style={{
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              Numero parqueadero: {creditData?.parking_number}
            </li>
          </ul>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontWeight: "bold",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            backgroundColor: "#dfe6ed",
            width: "85%",
          }}
        >
          <h1
            style={{
              fontSize: "1rem",
              fontWeight: "400",
              marginLeft: "1rem",
            }}
          >
            INFORMACION COMERCIAL
          </h1>
        </div>
        <div
          style={{
            width: "85%",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
          }}
        >
          <ul
            style={{
              listStyle: "none",
              padding: "0",
              display: "flex",
              flexDirection: "column",
              rowGap: "1rem",
            }}
          >
            <li
              style={{
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              Celular Comercial: {creditData?.phone}
            </li>
            <li
              style={{
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              Valor del inmueble: ${" "}
              {Number(creditData?.total_price).toLocaleString("es-CO")}
            </li>
          </ul>
          <ul
            style={{
              listStyle: "none",
              padding: "0",
              display: "flex",
              flexDirection: "column",
              rowGap: "1rem",
            }}
          >
            <li
              style={{
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              Valor posible del Subsidio: ${" "}
              {Number(creditData?.subsidy_value).toLocaleString("es-CO")}
            </li>
            <li
              style={{
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              Valor Cuota Separación: ${" "}
              {Number(creditData?.separation_value).toLocaleString("es-CO")}
            </li>
          </ul>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          padding: "1rem 0",
          color: "#014da1",
          display: "flex",
          flexDirection: "column",
          rowGap: "1rem",
        }}
      >
        <h1
          style={{
            width: "100%",
            textAlign: "center",
            fontSize: "1.5rem",
            fontWeight: "500",
            color: "#777777",
          }}
        >
          Tu plan de <strong>pagos mensual</strong>
        </h1>
        <div
          style={{
            width: "100%",
            display: "grid",
            gridTemplateColumns: "40% 60%",
            margin: "0 25%",
            columnGap: "1rem",
          }}
        >
          <div>
            <table
              style={{
                border: "1px solid #777777",
                width: "45.5rem",
                marginLeft: "-15%",
              }}
            >
              <tbody>
                <tr
                  style={{
                    borderBottom: "1px solid #777777",
                    textAlign: "center",
                    padding: "0.5rem 0",
                  }}
                >
                  <td
                    style={{
                      borderRight: "1px solid #777777",
                      padding: "0.5rem 0",
                      borderBottom: "1px solid #777777",
                      color: "#000000",
                      fontWeight: "bold",
                    }}
                  >
                    Concepto
                  </td>
                  <td
                    style={{
                      borderRight: "1px solid #777777",
                      padding: "0.5rem 0",
                      borderBottom: "1px solid #777777",
                      color: "#000000",
                      fontWeight: "bold",
                    }}
                  >
                    Fecha de pago
                  </td>
                  <td
                    style={{
                      padding: "0.5rem 0",
                      borderBottom: "1px solid #777777",
                      color: "#000000",
                      fontWeight: "bold",
                    }}
                  >
                    Valor
                  </td>
                </tr>
                {elements}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontWeight: "bold",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            backgroundColor: "#dfe6ed",
            width: "85%",
          }}
        >
          <h1
            style={{
              fontSize: "1rem",
              fontWeight: "400",
              marginLeft: "1rem",
            }}
          >
            Notas Legales
          </h1>
        </div>
        <div
          style={{
            width: "85%",
          }}
        >
          <ul
            style={{
              listStyle: "none",
              padding: "0",
              display: "flex",
              flexDirection: "column",
              rowGap: "1rem",
            }}
          >
            <li
              style={{
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              * Las anteriores fechas son estimadas y pueden anticiparse o
              prorrogarse.
            </li>
            <li
              style={{
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              • La construcción de este proyecto solo se iniciará cuando se
              logre el punto de equilibrio en ventas y se cuente con la
              correspondiente licencia de construcción. Por esta razón la fecha
              de suscripción de la escritura pública que perfeccione la
              compraventa y la fecha de entrega del inmueble es susceptible de
              modificaciones.
            </li>
            <li
              style={{
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              • Una vez se alcance el punto de equilibrio en ventas y se obtenga
              la radicación del permiso de ventas para el proyecto RESERVA DEL
              PRADO, de conformidad con la normatividad vigente, las partes
              pactarán la fecha de la firma del contrato de promesa de
              compraventa dentro de los veinte (20) días calendario siguientes a
              la citación por parte del Constructor. En el contrato de promesa
              de compraventa se acordarán, entre otros aspectos, la fecha de
              otorgamiento de la escritura pública con la que se da cumplimiento
              a la venta prometida y la fecha de entrega del inmueble objeto del
              citado contrato la cual está estimada
            </li>
            <li
              style={{
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              • El pago de la totalidad de la cuota inicial acordada no implica
              y/o da a entender que el Constructor este obligado a la entrega
              inmediata del inmueble. En caso de que el pago del saldo del
              inmueble se realice a través de financiación, el inmueble será
              entregado únicamente una vez la financiación sea desembolsada al
              Constructor o a quien esta indique o autorice de conformidad con
              la estructuración de pagos del proyecto, esto aplica también para
              pagos acordados por concepto de subsidios.
            </li>
            <li
              style={{
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              • Manifestaciones del Adquirente: Con la firma del presente
              documento manifiesto expresamente, que me han suministrado
              información clara, veraz y suficiente - y que con base en ellas he
              tomado la decisión de adquirir - sobre las características
              generales del proyecto RESERVA DEL PRADO, de las zonas comunes, de
              los parqueaderos que forman parte de las zonas comunes y serán de
              uso exclusivo de los compradores y/o futuros propietarios, de las
              condiciones generales de la unidad privada, así como las fechas
              previstas para firma del contrato de promesa de compraventa,
              escritura de compraventa y entrega del inmueble, quedando en todo
              caso claro que se trata de fechas aproximadas y podrán ser
              modificadas posteriormente. Manifiesto que he sido informado que
              las representaciones gráficas, planos, fotografías, renders,
              arborización, imágenes del Proyecto RESERVA DEL PRADO y sus
              unidades inmobiliarias están sujetas a modificaciones por parte
              del Constructor de manera discrecional debido a ajustes técnicos y
              al proceso constructivo. De igual forma, manifiesto que conozco
              que las especificaciones generales del proyecto en cuanto a
              acabados, áreas y demás condiciones arquitectónicas las cuales
              fueron presentadas en la sala de ventas y/o por el Constructor,
              pueden sufrir modificaciones y diferir de los acabados y
              especificaciones finales. El mobiliario, los electrodomésticos,
              acabados y demás elementos que aparecen en las imágenes del
              proyecto y apartamento modelo son ilustrativas, las cuales pueden
              ser objeto de modificación, acorde al desarrollo del proyecto, por
              lo tanto, no configuran compromiso contractual por parte del
              Constructor. Así mismo, me fue informado que por tratarse de un
              anteproyecto arquitectónico, este podrá sufrir modificaciones por
              circunstancias técnicas, topográficas, de suelos, estructurales,
              de normatividad o de mercadeo que tuviere que hacer la
              Constructora, en desarrollo de la construcción que se vaya
              adelantando y que podrían variar el número de inmuebles, de
              parqueaderos comunales y de visitantes o el diseño de algunas
              partes de las zonas comunes, situación que me será comunicada.
              Finalmente, manifiesto que he sido informado que el área privada y
              construida del inmueble objeto de negociación puede sufrir
              modificaciones como consecuencia de ajustes técnicos o derivados
              del proceso de obtención de la licencia de construcción. Teniendo
              en cuenta lo anterior, manifiesto conocer y aceptar que las áreas
              y linderos definitivos del inmueble objeto de negociación serán
              aquellos incluidos en el contrato de promesa de compraventa y en
              el reglamento de propiedad horizontal.
            </li>
            <li
              style={{
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              • Autorización consulta de datos en las centrales de riesgo: Con
              la firma de la presente cotización, autorizo de manera expresa e
              irrevocable a OTACC S.A.S. para que con ocasión de los productos,
              promociones, bienes y servicios y, en general, cualquier tipo de
              obligación contraída o que se contraiga en adelante con el
              Constructor esta pueda consultar, en cualquier tiempo y en
              cualquier central de información de riesgo legalmente autorizada,
              toda la información relevante para conocer mi desempeño como
              deudor, mi capacidad de pago o para valorar el riesgo futuro de
              suministrarme un bien o servicio y contraer cualquier obligación.
            </li>
            <li
              style={{
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              • Autorización para tratamiento de Datos Personales: Teniendo en
              cuenta el Régimen general de Protección de Datos Personales
              previsto en la ley 1581 de 2012, por medio del presente escrito
              declaro que he sido informado de: (i) Que OTACC S.A.S. y demás
              sociedades de la compañía, en el desarrollo de la actividad
              comercial que ejerce actuará como usuario de mi información
              personal, bien sea porque la misma sea suministrada por un
              operador o fuente o porque yo se la facilite directamente; (ii)
              Que mis datos serán tratados para fines contractuales,
              comerciales, de atención al cliente y mercadeo; (iii) Que mis
              derechos como titular de la información son los contemplados en la
              Constitución Política de Colombia y la Ley, dentro de los cuales
              se resaltan el de conocer, actualizar, rectificar y solicitar la
              supresión de mis datos personales cuando en el tratamiento de los
              datos no se respeten los principios, derechos y garantías
              constitucionales y legales, así como el derecho de revocar la
              autorización otorgada para el tratamiento de mis datos personales;
              (iv) Que OTACC S.A.S. ha puesto a mi su página web www.otacc.com y
              la sala de ventas en el horario de Lunes a Domingo de 9:00am a
              5:00p.m , para la atención de requerimientos relacionados con el
              tratamiento de mis datos personales y el ejercicio de los derechos
              aquí mencionados. (v) Que en la página web de OTACC S.A.S. se han
              dispuesto para consulta las políticas de tratamiento de
              información, las cuales me comprometo a leer. Teniendo en cuenta
              lo anterior, con la firma de esta cotización, autorizo de manera
              expresa a OTACC S.A.S. y demás sociedades de la compañía para (i)
              Utilizar y recopilar la información entregada, la cual será
              utilizada en el desarrollo de los procesos internos de la compañía
              tales como venta, facturación, cartera, información de productos y
              servicios, promociones, publicidad, planes de referidos, encuestas
              y demás actividades del giro ordinario de la compañía; (ii)
              Compartir mis datos personales con entidades financieras para
              documentación y aprobación de créditos para vivienda; (iii)
              Actualizar o modificar sus políticas de tratamiento de información
              con el propósito de atender la reglamentación que se encuentre
              vigente. El canal institucional dispuesto para la atención de
              servicio al cliente, es el correo{" "}
              <a href="https://reservadelprado.co/">
                reservadelprado@otacc.com
              </a>
              .
            </li>
            <li
              style={{
                fontSize: "0.9rem",
                fontWeight: "400",
              }}
            >
              Esta cotización tiene vigencia de 5 días calendario.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SimulatorPdf;
